<template>
  <div>
    <h2 class="my-5">
      <b>Confirm files before proceeding</b>
    </h2>

    <div class="row">
      <div class="col-sm-4 text-center pt-3">
        <img class="doc-icn" src="../assets/images/paper.svg" />
      </div>
      <div class="col-sm-8">
        <table>
          <tr>
            <th>Filename</th>
            <td>{{ selectedFile.name }}</td>
          </tr>
          <tr>
            <th>Last Modfied</th>
            <td>{{ new Date(selectedFile.lastModified).toDateString() }}</td>
          </tr>
          <tr>
            <th>Type</th>
            <td>{{ selectedFile.type }}</td>
          </tr>
          <tr>
            <th>size</th>
            <td>{{ bytesToSize(selectedFile.size) }}</td>
          </tr>
        </table>
      </div>
    </div>
    <transition>
      <div key="1" v-if="!shaSum" class="progress mt-5">
        <div class="progress-bar p-3" role="progressbar" :style="{ width: hashingProgress + '%' }" aria-valuenow="25"
          aria-valuemin="0" aria-valuemax="100">
          <strong>{{ hashingProgress }} %</strong>
        </div>
      </div>
      <div key="2" v-else class="hash-container border rounded px-4 mt-5">
        <strong>
          Hash :

          <span class="txt-blue">{{ shaSum }}</span>
        </strong>
      </div>
    </transition>
    <transition>
      <div v-if="serverTimestamp" class="hash-container border rounded px-4 mt-2">
        <strong>
          Server Timestamp :

          <span class="txt-blue">{{ serverTimestamp }} </span>
        </strong>

        <small class="text-muted ml-3">{{ Date(serverTimestamp) }}</small>
      </div>
    </transition>
    <transition>
      <div v-if="errorMessage" class="danger-info p-3 my-5">
        <i class="fa fa-exclamation-triangle mr-3" />{{ errorMessage }}
      </div>
    </transition>
    <div class="d-flex pt-5 steps-button">
      <button class="btn back-btn ml-0 mr-auto" @click="nextHandler(1)">
        <i class="fa fa-angle-left mr-2" /> Back
      </button>
      <button class="btn next-btn ml-auto mr-0" @click="nextHandler(3)" :disabled="!isStepComplete">
        Next <i class="fa fa-angle-right ml-2" />
      </button>
    </div>
  </div>
</template>
<script>
import cfg from "../config"
import bytesToSize from "../functions/bytesToSize"
import chunkedSHA256 from "../functions/chunkedSHA256"
import timeout from "../functions/timeout"
export default {
  name: "FileSelector",
  props: {
    nextHandler: Function,
    signFileCB: Function,
    selectedFile: File,
  },
  data() {
    return {
      shaSum: null,
      oldFileName: "",
      oldFileSize: "",
      isStepComplete: false,
      hashingProgress: 0,
      serverTimestamp: null,
      errorMessage: null,
    }
  },
  methods: {
    async calculateHash() {
      try {
        await timeout(100)
        let tmp = await chunkedSHA256(this.selectedFile, (progress) => {
          this.hashingProgress = Math.round(progress * 100)
        })
        await timeout(100)
        this.shaSum = tmp
        await this.getTimestamp()
      } catch (e) {
        this.errorMessage = "Unable to generate timestamp"
      }
    },
    bytesToSize,
    getTimestamp() {
      return new Promise((resolve, reject) => {
        fetch(
          `${cfg.esignAPIURL}/digitalsignature/otu-sign/` +
          this.shaSum
        )
          .then((res) => res.json())
          .then((data) => {
            if (data) {
              this.isStepComplete = true
              this.serverTimestamp = data.timestamp
              this.signFileCB([
                {
                  filename: this.selectedFile.name,
                  timestamp: Date(this.serverTimestamp),
                  signatureID: data.signatureID,
                },
              ])
              resolve()
            }
          })
          .catch((e) => {
            reject()
          })
      })
    },
  },
  activated() {
    if (this.oldFileName !== this.selectedFile.name || this.oldFileSize !== this.selectedFile.size) {
      this.shaSum = null
      this.oldCaptureURL = this.captureURL
      this.hashingProgress = 0
      this.errorMessage = null
      this.calculateHash()
    }
  },
  mounted() {
    this.oldFileName = this.selectedFile.name
    this.oldFileSize = this.selectedFile.size
    this.calculateHash()
  },
}
</script>
<style scoped>
table {
  table-layout: fixed;
  width: 100%;
}

tr {
  max-width: 100%;
  overflow: hidden;
  text-align: left;
}

td,
th {
  min-width: 130px;
  max-width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 8px;
}

.txt-blue {
  color: #10a2e6;
}

.hash-container {
  padding: 10px;
  word-break: break-all;
}

.progress-text {
  animation: glow 1s infinite linear;
}

.progress-bar {
  background: #00c781;
}

.progress {
  height: 45px;
}

.doc-icn {
  width: 100px;
}

.v-enter-active {
  animation: dropIn 0.5s;
}

.v-leave {
  animation: dropIn 1s reverse;
}

@keyframes dropIn {
  0% {
    opacity: 0;
    transform: translateY(-10%);
  }

  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SignFile.vue